import { IProductElement } from '../../models/project.model';
import type { Characteristics } from '../../models/product-characteristics.model';
import { ElementPath } from '../recursive-element.helpers';
import { getProductRecord } from '../product.helpers';
import { genericProductsLookup } from '../../generic-products';

/**
 * Get the characteristics of the generic product behind a product element.
 * Reads from the fresh generic catalogue first since {@link Baseline.products}
 * may be a stale snapshot from before maintenance/lifetime data existed.
 */
export const getGenericProductCharacteristics = (
  path: ElementPath,
  productElement: IProductElement,
): Characteristics | undefined => {
  // Raw read instead of getGenericProductId — custom products have no valid
  // generic id and must not crash the mapper, they simply have no characteristics
  const genericId =
    productElement.generic_product_id ?? productElement.product_id;
  if (!genericId) return undefined;
  return (
    genericProductsLookup[genericId]?.characteristics ??
    getProductRecord(path)[genericId]?.characteristics
  );
};
